import { IBehaviorResponseStatus } from "@/Models/Lookup/IBehaviorResponseStatus";
import { IBehaviorResponseType } from "@/Models/Lookup/IBehaviorResponseType";
import { IBehaviorType } from "@/Models/Lookup/IBehaviorType";

export class BehaviorResponseLookupWrapper {
	statuses = [] as IBehaviorResponseStatus[];
	behaviorTypes = [] as IBehaviorType[];
	responseTypes = [] as IBehaviorResponseType[];
}
